import React, {
  useState,
  useContext,
  useRef,
  useEffect,
  useCallback,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid } from "@mui/material";
import {
  checkErrorStateExists,
  formStateHandler,
} from "../../../../utils/utils";
import TextInput from "../../../../framework/TextInput";
import Checkbox from "../../../../framework/Checkbox";
import GlobalContext from "../../../../framework/GlobalContext";
import _ from "lodash";
import NumberInput from "../../../../framework/NumberInput";
const VisitsTab = ({
  validateForm = () => {},
  removeErrorStateOnChange = () => {},
}) => {
  const addDistributorSalesManNameRef = useRef();
  const addDistributorMondayRef = useRef();
  const addDistributorTuesdayRef = useRef();
  const addDistributorWednesdayRef = useRef();
  const addDistributorThursdayRef = useRef();
  const addDistributorFridayRef = useRef();
  const addDistributorSaturdayRef = useRef();
  const addDistributorSundayRef = useRef();
  const addDistributorVisitsContactRef = useRef();
  const [localFormState, setLocalFormState] = useState(null);
  const { formState, errorState } = useSelector(
    (state) => state.commonReducer.common.addDistributor
  );
  const dispatch = useDispatch();
  const { setCurrentComponent } = useContext(GlobalContext);
  const dispatchFormState = (newState) => {
    dispatch({
      type: "set_add_distributor_form_state",
      payload: newState,
    });
  };
  const debounceDispatchFormState = _.debounce(dispatchFormState, 1);
  const handleFormChange = useCallback(
    (fieldName, fieldValue, isSelect = false, options) => {
      let newFormState = formStateHandler(
        formState,
        fieldName,
        fieldValue,
        isSelect,
        options
      );
      debounceDispatchFormState(newFormState);
    },
    [debounceDispatchFormState, formState]
  );
  const initializeForm = useCallback(
    (formState) => {
      if (formState) {
        addDistributorSalesManNameRef.current.value =
          formState.distributorSalesPerson || "";
      }
    },
    [addDistributorSalesManNameRef]
  );
  const withPhoneCap = ({ value }) => value.length <= 10;
  useEffect(() => {
    addDistributorSalesManNameRef.current.focus({ preventScroll: true });
  }, [addDistributorSalesManNameRef]);
  useEffect(() => {
    if (formState && !localFormState) {
      setLocalFormState(formState);
      initializeForm(formState);
    }
  }, [localFormState, initializeForm, formState]);
  return (
    <Grid
      sx={{
        margin: "5px 0px 5px -10px",
        width: "100%",
      }}
      container
      columnSpacing={2}
      rowSpacing={3}
      columns={12}
    >
      <Grid item xs={3}>
        <TextInput
          id="add_distributor_visits_salesman_name"
          name="distributorSalesPerson"
          ref={addDistributorSalesManNameRef}
          label="Sales-man Name"
          onFocus={() =>
            setCurrentComponent("add_distributor_visits_salesman_name")
          }
          onChange={(e) => {
            handleFormChange("distributorSalesPerson", e.target.value);
          }}
          inputProps={{
            "data-markers": JSON.stringify({
              up: "",
              down: "add_distributor_visits_monday",
              left: "",
              right: "add_distributor_visits_contact",
            }),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <NumberInput
          id="add_distributor_visits_contact"
          name="distributorSalesMobile"
          ref={addDistributorVisitsContactRef}
          label="Contact Number"
          isAllowed={withPhoneCap}
          allowNegative={false}
          decimalScale={0}
          onFocus={() => setCurrentComponent("add_distributor_visits_contact")}
          value={localFormState?.distributorSalesMobile}
          onChange={(e) => {
            setLocalFormState((prev) => {
              return { ...prev, distributorSalesMobile: e.target.value };
            });
            handleFormChange("distributorSalesMobile", e.target.value);
            removeErrorStateOnChange("add_distributor_visits_contact");
          }}
          onBlur={() =>
            validateForm("distributorSalesMobile", localFormState, errorState)
          }
          inputProps={{
            "data-markers": JSON.stringify({
              up: "",
              down: "add_distributor_visits_wednesday",
              left: "add_distributor_visits_salesman_name",
              right: "add_distributor_visits_monday",
            }),
          }}
          error={checkErrorStateExists(
            "add_distributor_visits_contact",
            errorState
          )}
        />
      </Grid>
      <Grid item xs={12} sx={{ fontSize: "1rem", fontWeight: "700" }}>
        Sales Visits
      </Grid>
      <Grid item xs={1.5}>
        <Checkbox
          id="add_distributor_visits_monday"
          name="visitMonday"
          ref={addDistributorMondayRef}
          label="Monday"
          checked={(formState && formState.visitMonday) || false}
          onFocus={() => setCurrentComponent("add_distributor_visits_monday")}
          onChange={(event) =>
            handleFormChange("visitMonday", event.target.checked)
          }
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_visits_salesman_name",
              down: "add_distributor_visits_salesman_name",
              left: "add_distributor_visits_contact",
              right: "add_distributor_visits_tuesday",
            }),
          }}
        />
      </Grid>
      <Grid item xs={1.5}>
        <Checkbox
          id="add_distributor_visits_tuesday"
          name="visitTuesday"
          ref={addDistributorTuesdayRef}
          label="Tuesday"
          checked={(formState && formState.visitTuesday) || false}
          onFocus={() => setCurrentComponent("add_distributor_visits_tuesday")}
          onChange={(event) =>
            handleFormChange("visitTuesday", event.target.checked)
          }
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_visits_salesman_name",
              down: "add_distributor_visits_salesman_name",
              left: "add_distributor_visits_monday",
              right: "add_distributor_visits_wednesday",
            }),
          }}
        />
      </Grid>
      <Grid item xs={1.5}>
        <Checkbox
          id="add_distributor_visits_wednesday"
          name="visitWednesday"
          ref={addDistributorWednesdayRef}
          label="Wednesday"
          checked={(formState && formState.visitWednesday) || false}
          onFocus={() =>
            setCurrentComponent("add_distributor_visits_wednesday")
          }
          onChange={(event) =>
            handleFormChange("visitWednesday", event.target.checked)
          }
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_visits_contact",
              down: "add_distributor_visits_salesman_name",
              left: "add_distributor_visits_tuesday",
              right: "add_distributor_visits_thursday",
            }),
          }}
        />
      </Grid>
      <Grid item xs={1.5}>
        <Checkbox
          id="add_distributor_visits_thursday"
          name="visitThursday"
          ref={addDistributorThursdayRef}
          label="Thursday"
          checked={(formState && formState.visitThursday) || false}
          onFocus={() => setCurrentComponent("add_distributor_visits_thursday")}
          onChange={(event) =>
            handleFormChange("visitThursday", event.target.checked)
          }
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_visits_contact",
              down: "add_distributor_visits_salesman_name",
              left: "add_distributor_visits_wednesday",
              right: "add_distributor_visits_friday",
            }),
          }}
        />
      </Grid>
      <Grid item xs={1.5}>
        <Checkbox
          id="add_distributor_visits_friday"
          name="visitFriday"
          ref={addDistributorFridayRef}
          label="Friday"
          checked={(formState && formState.visitFriday) || false}
          onFocus={() => setCurrentComponent("add_distributor_visits_friday")}
          onChange={(event) =>
            handleFormChange("visitFriday", event.target.checked)
          }
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_visits_contact",
              down: "add_distributor_visits_salesman_name",
              left: "add_distributor_visits_thursday",
              right: "add_distributor_visits_saturday",
            }),
          }}
        />
      </Grid>
      <Grid item xs={1.5}>
        <Checkbox
          id="add_distributor_visits_saturday"
          name="visitSaturday"
          ref={addDistributorSaturdayRef}
          label="Saturday"
          checked={(formState && formState.visitSaturday) || false}
          onFocus={() => setCurrentComponent("add_distributor_visits_saturday")}
          onChange={(event) =>
            handleFormChange("visitSaturday", event.target.checked)
          }
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_visits_contact",
              down: "add_distributor_visits_salesman_name",
              left: "add_distributor_visits_friday",
              right: "add_distributor_visits_sunday",
            }),
          }}
        />
      </Grid>
      <Grid item xs={1.5}>
        <Checkbox
          id="add_distributor_visits_sunday"
          name="visitSunday"
          ref={addDistributorSundayRef}
          label="Sunday"
          checked={(formState && formState.visitSunday) || false}
          onFocus={() => setCurrentComponent("add_distributor_visits_sunday")}
          onChange={(event) =>
            handleFormChange("visitSunday", event.target.checked)
          }
          inputProps={{
            "data-markers": JSON.stringify({
              up: "add_distributor_visits_contact",
              down: "add_distributor_visits_salesman_name",
              left: "add_distributor_visits_saturday",
              right: "add_distributor_visits_salesman_name",
            }),
          }}
        />
      </Grid>
    </Grid>
  );
};
export default VisitsTab;
